import { Outlet } from 'react-router-dom';

import { CookieBanner } from '@/components/CookieBanner';

const PublicLayout = () => (
    <>
        <Outlet />
        <CookieBanner />
    </>
);

export { PublicLayout };
